import { useState } from "react";
import PaperIcon from "../../assets/images/paper.png";
import Star from "../../assets/images/star.png";

const FAQ = () => {
  const [collapse, setCollapse] = useState();

  return (
    <section
      id="sss"
      className="w-full flex justify-center bg-[#FFF8EB] py-10 lg:py-32 relative"
    >
      <img
        data-aos="fade-right"
        loading="lazy"
        className="absolute left-6 top-14 w-16 md:left-24 md:top-24 md:w-36"
        src={PaperIcon}
        alt="paper icon"
      />
      <img
        data-aos="flip-left"
        loading="lazy"
        className="absolute right-6 lg:right-10 top-1/2 md:top-1/3 w-14 md:w-32"
        src={Star}
        alt="star"
      />
      <div className="w-4/5 max-w-screen-xl space-y-10 lg:space-y-24">
        <div className="w-full text-center">
          <h4
            style={{ fontFamily: "Gotham" }}
            className="text-[25px] lg:text-7xl text-[#244C5A] font-bold"
          >
            SIKÇA SORULAN
          </h4>
          <h4 className="text-[25px] lg:text-7xl text-[#EF7C61] font-bold">
            SORULAR
          </h4>
        </div>
        <div className="accordion flex flex-wrap" id="accordionExample">
          <div className="accordion-item w-full lg:w-1/2 p-2">
            <div
              className={
                collapse === 1
                  ? "border-[#EF7C61] border-[3.2px]"
                  : "border-[#DDDDDD] border-[3.2px]"
              }
            >
              <h2
                style={{ fontFamily: "Poppins" }}
                className="accordion-header mb-0 text-[12px] lg:text-[22px]"
                id="headingOne"
              >
                <button
                  onClick={() =>
                    collapse !== 1 ? setCollapse(1) : setCollapse(null)
                  }
                  style={{ color: "#244C5A" }}
                  className="accordion-button bg-transparent collapsed relative flex items-center w-full py-4 px-5 font-semibold text-left border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  ETKİNLİĞE KİMLER KATILABİLİR?
                </button>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div
                  style={{ fontFamily: "Poppins" }}
                  className="accordion-body py-4 px-5 text-[#131B42] text-[19px]"
                >
                  Şirketlerin düzenlediği genç yetenek programlarının
                  süreçlerini ve detaylarını dinlemek isteyen herkes
                  katılabilir.
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item w-full lg:w-1/2 p-2">
            <div
              className={
                collapse === 2
                  ? "border-[#EF7C61] border-[3.2px]"
                  : "border-[#DDDDDD] border-[3.2px]"
              }
            >
              <h2
                style={{ fontFamily: "Poppins" }}
                className="accordion-header mb-0 text-[12px] lg:text-[22px]"
                id="headingTwo"
              >
                <button
                  onClick={() =>
                    collapse !== 2 ? setCollapse(2) : setCollapse(null)
                  }
                  style={{ color: "#244C5A" }}
                  className="accordion-button bg-transparent collapsed relative flex items-center w-full py-4 px-5 font-semibold text-left border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  ETKİNLİĞE NASIL KATILABİLİRİM?
                </button>
              </h2>
              <div
                id="collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample"
              >
                <div
                  style={{ fontFamily: "Poppins" }}
                  className="accordion-body py-4 px-5 text-[#131B42] text-[19px]"
                >
                  Yayın saatinden hemen önce sitemize giriş yaparak canlı yayını
                  izleyebilirsin. Etkinlik öncesinde canlı yayın giriş
                  bilgilerini kayıt olduğun mail adresine göndereceğiz.
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item w-full lg:w-1/2 p-2">
            <div
              className={
                collapse === 3
                  ? "border-[#EF7C61] border-[3.2px]"
                  : "border-[#DDDDDD] border-[3.2px]"
              }
            >
              <h2
                style={{ fontFamily: "Poppins" }}
                className="accordion-header mb-0 text-[12px] lg:text-[22px]"
                id="headingThree"
              >
                <button
                  onClick={() =>
                    collapse !== 3 ? setCollapse(3) : setCollapse(null)
                  }
                  style={{ color: "#244C5A" }}
                  className="accordion-button bg-transparent collapsed relative flex items-center w-full py-4 px-5 font-semibold text-left border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  ETKİNLİĞE KATILMAK İÇİN ÜCRET ÖDEMEK GEREKİYOR MU?
                </button>
              </h2>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div
                  style={{ fontFamily: "Poppins" }}
                  className="accordion-body py-4 px-5 text-[#131B42] text-[19px]"
                >
                  <strong>This is the second item's accordion body.</strong> It
                  is hidden by default, until the collapse plugin adds the
                  appropriate classNamees that we use to style each element.
                  These classNamees control the overall appearance, as well as
                  the showing and hiding via CSS transitions. You can modify any
                  of this with custom CSS or overriding our default variables.
                  It's also worth noting that just about any HTML can go within
                  the <code>.accordion-body</code>, though the transition does
                  limit overflow.
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item w-full lg:w-1/2 p-2">
            <div
              className={
                collapse === 4
                  ? "border-[#EF7C61] border-[3.2px]"
                  : "border-[#DDDDDD] border-[3.2px]"
              }
            >
              <h2
                style={{ fontFamily: "Poppins" }}
                className="accordion-header mb-0 text-[12px] lg:text-[22px]"
                id="headingFour"
              >
                <button
                  onClick={async () =>
                    collapse !== 4
                      ? await setCollapse(4)
                      : await setCollapse(null)
                  }
                  style={{ color: "#244C5A" }}
                  className="accordion-button bg-transparent collapsed relative flex items-center w-full py-4 px-5 font-semibold text-left border-0 rounded-none transition focus:outline-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  TEKNİK BİR ARIZA YAŞADIĞIMDA NASIL ÇÖZEBİLİRİM?
                </button>
              </h2>
              <div
                id="collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#accordionExample"
              >
                <div
                  style={{ fontFamily: "Poppins" }}
                  className="accordion-body py-4 px-5 text-[#131B42] text-[19px]"
                >
                  <strong>This is the second item's accordion body.</strong> It
                  is hidden by default, until the collapse plugin adds the
                  appropriate classNamees that we use to style each element.
                  These classNamees control the overall appearance, as well as
                  the showing and hiding via CSS transitions. You can modify any
                  of this with custom CSS or overriding our default variables.
                  It's also worth noting that just about any HTML can go within
                  the <code>.accordion-body</code>, though the transition does
                  limit overflow.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
